import { default as lookupWordByUid } from '../lookupWordByUid';

export default (state, subject) => lookupWordByUid(state, `m${subject}`);
